module.exports = __webpack_public_path__ + "static/media/jace.79eceeda.gif";